import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DaysView } from 'components/availability/form/list_view/days_view';
const customHoursViewIsTabletUpCss = "cmdhj99";
const customHoursViewIsRedesignStylingCss = "c1vdnbdd";
const customHoursViewCompactCss = "c4md82k";
const customHoursViewIsExtraSmallPhoneCss = "c1t23szr";
const customHoursViewCss = "c18g2ayk";
export const CustomHoursView = forwardRef((props, ref) => {
  const {
    compact,
    isExtraSmallPhone
  } = props;
  const displayLegend = false;
  const alwaysAbbreviate = true;
  const allowCopy = props.allowCopy || false;
  const isTabletUp = useDeviceType('isTabletUp');
  const isRedesignStyling = props.redesignStyling;
  return <DaysView ref={ref} {...props} displayLegend={displayLegend} alwaysAbbreviate={alwaysAbbreviate} allowCopy={allowCopy} className={classNames(customHoursViewCss, {
    [customHoursViewIsTabletUpCss]: isTabletUp,
    [customHoursViewIsRedesignStylingCss]: isRedesignStyling,
    [customHoursViewCompactCss]: compact,
    [customHoursViewIsExtraSmallPhoneCss]: isExtraSmallPhone
  }, props.className)} />;
});

require("./custom_hours.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./custom_hours.js");